import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store/store'
import VueAnalytics from 'vue-analytics'
import content from '@/data/content'
import '@/utils/watchPageVisibility'
import '@/assets/css/main.scss'
import '@/filters/filters'
import 'blueimp-canvas-to-blob'

Vue.config.productionTip = false

Vue.prototype.$content = content
Vue.use(VueAnalytics, { id: 'UA-75408423-8', router })

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
